import Footer from "../Footer";
import Header from "../Header";

const MainLayout = ({ children }) => {
  return (
    <>
      <Header />
      {children}
      <Footer />
    </>

  );
};

export default MainLayout;